/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import { object, func } from 'prop-types';
import {
    MenuItem, Select, InputLabel, FormControl,
    // Grid,
} from '@material-ui/core/';
import { makeStyles } from '@material-ui/core/styles';
import { sortRecipients } from '../Helpers/Helpers';

const useStyles = makeStyles(() => ({
    label: {
        fontSize: '14px', fontWeight: '700', lineHeight: '20px', color: 'black', paddingRight: '10px', textAlign: 'right',
    },
    select: {
        fontWeight: '400',
        fontSize: '12px',
        lineHeight: '18px',
        '& .mbp-account-MuiSvgIcon-root': {
            color: '#262626', // Change the color here
        },
        '& .mbp-account-MuiMenuItem-root': {
            fontWeight: '400', fontSize: '12px', lineHeight: '18px',
        },
    },
    formControl: {
        width: 'fit-content',
        border: '1px solid #555555',
        borderRadius: '3px',
        padding: '5px 12px 5px 12px',
    },
    menuItem: {
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '18px',
    },
    container: {
        display: 'flex', 
        alignItems: 'center'
    }
}));
const SortRecipientBook = ({ recipientState, setRecipientState }) => {
    const classes = useStyles();
    const { addressBookResponse } = recipientState;

    const [sortOption, setSortOption] = useState('asc');

    useEffect(() => {
        setRecipientState((prevState) => {
            if (prevState?.addressBookResponse?.sortOption !== sortOption) {
                return { addressBookResponse: { ...addressBookResponse, addressList: sortRecipients(sortOption, addressBookResponse), sortOption } };
            }
            return recipientState;
        });
    }, [sortOption, recipientState]);

    return (
        <div className={classes.container}>
            <InputLabel className={classes.label}>Sort:</InputLabel>
            <FormControl fullWidth className={classes.formControl}>
                <Select
                    disableUnderline
                    className={classes.select}
                    value={sortOption}
                    onChange={(e) => setSortOption(e.target.value)}
                >
                    <MenuItem className={classes.menuItem} value="asc">Last Name A - Z</MenuItem>
                    <MenuItem className={classes.menuItem} value="desc">Last Name Z - A</MenuItem>
                    <MenuItem className={classes.menuItem} value="reminders">Upcoming Reminders</MenuItem>
                </Select>
            </FormControl>
        </div>
    )
};

SortRecipientBook.propTypes = {
    recipientState: object.isRequired,
    setRecipientState: func.isRequired,
};

export default SortRecipientBook;
